import React, { ComponentType, useState } from "react"
import { useTranslation } from "react-i18next"
import { compose } from "@reduxjs/toolkit"

import { useAppDispatch } from "redux/hooks"
import { withCookieConsent } from "hocs/cookie"
import { updateSession } from "redux/features/cookie/cookieConsentSlice"
import {
  AccordionComponent as Accordion,
  Summary,
  Details,
} from "components/ui/Accordion"
import { Card, Title } from "components/Sessions/Consent/elements"
import Form from "components/Sessions/Consent/Form"
import { SessionConsentValues, SessionConsentType } from "types"

type Props = {
  session: SessionConsentType
}

const SessionConsentComponent = ({ session }: Props) => {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()

  const { terms, privacy, advertisement } = session
  const [isExpanded, setExpanded] = useState(
    !(terms && privacy && advertisement),
  )

  const handleChange = () => {
    setExpanded(!isExpanded)
  }

  const handleSubmit = (values: SessionConsentValues) => {
    const { terms, privacy, advertisement } = values

    setTimeout(() => {
      if (terms && privacy && advertisement) {
        setExpanded(false)
      }
    }, 300)

    dispatch(updateSession(values))
  }

  return (
    <Card elevation={0}>
      <Accordion
        sx={{ margin: 0, padding: 0 }}
        expanded={isExpanded}
        onChange={handleChange}
      >
        <Summary>
          <Title>{t("pages.sessions.consent.title")}</Title>
        </Summary>
        <Details>
          <Form initialValues={session} onSubmit={handleSubmit} />
        </Details>
      </Accordion>
    </Card>
  )
}

export default compose<ComponentType>(withCookieConsent)(
  SessionConsentComponent,
)
